export default "__VITE_ASSET__BGXIC9Pt__"